// offline-modal.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-offline-modal',
  standalone: true,
  templateUrl: './offline-modal.component.html',
  styleUrls: ['./offline-modal.component.scss']
})
export class OfflineModalComponent {
  // Optional logic goes here
  // reportError() {
  //   console.log('User clicked to report error');
  // }
}
